<template>
  <div class="container training-list-wrapper" v-if="trainingList.length > 0">
    <div class="title-wrapper">
      <div class="title-space">
        <h2 class="h2-bigger" style="margin-bottom: 15px;">Treinamentos em evidência</h2>
        <div class="hr-yellow hr-45"></div>
      </div>
      <button class="border" @click="registerTraining">Cadastre seus treinamentos</button>
    </div>
    <br><br><br>
    <div class="row training-list hide-mobile">
      <div class="col-md-3" v-for="training in trainingList" :key="training._id">
        <training-item :training=training :grey=true></training-item>
      </div>

      <div class="col-md-12" style="text-align: center;" v-if="canLoadMore">
        <button class="border border-bigger" @click="loadMore()">Carregar mais treinamentos</button>

      </div>
    </div>
    <div class="row training-list only-mobile">
      <div class="col-md-3" v-for="training in trainingListMobile" :key="training._id">
        <training-item :training=training :grey=true></training-item>
      </div>

      <div class="col-md-12" style="text-align: center;" v-if="canLoadMore">
        <button class="border border-bigger" @click="loadMore(true)">Carregar mais treinamentos</button>

      </div>
    </div>

  </div>
</template>

<script>
import { server, local } from "../js/variables.js";
import moment from 'moment';
import userMixin from "../mixins/userMixin.js";
import TrainingItem from "./TrainingItem.vue";

export default {
  mixins: [userMixin],
  components: {
    TrainingItem,
  },
  data() {
    return {
      trainingList: [],
      trainingListMobile: [],
      opportunityNow: {},
      endpoint: "/api/course",
      maxItems: 4,
      pageItems: 4,
      maxItemsMobile: 1,
      pageItemsMobile: 1,
      page: 0,
      canLoadMore: true,

    };
  },
  mounted() {
    this.loadTrainings();
  },
  methods: {
    loadMore(isMobile) {
      if (isMobile) {
        this.maxItemsMobile = this.maxItemsMobile + this.pageItemsMobile;
        this.page = this.page + 1;
        this.loadTrainings(true);
      } else {
        this.maxItems = this.maxItems + this.pageItems;
        this.page = this.page + 1;
        this.loadTrainings();
      }
    },
    loadTrainings(isMobile) {
      let self = this;
      let limit = isMobile ? this.pageItemsMobile : this.pageItems

      let header = JSON.parse(JSON.stringify(server.config));
      header["params"] = {
        limit: limit,
        page: this.page,
        visible: 1,
      };

      this.axios
        .get(server.url + this.endpoint, header)
        .then(function (response) {
          let responseData = response.data.data;
          if (self.page == 0) {
            self.trainingList = [];
            self.trainingListMobile = [];
          }

          for (let course of responseData.course_list) {
            course.created_at = moment(course.created_at).add(4, 'hours').format('DD/MM/YYYY');
          }

          if (responseData.course_list.length > 0) {
            self.trainingList = responseData.course_list
            self.trainingListMobile = responseData.course_list.slice(0, self.pageItemsMobile)
          }

          if (responseData.course_list.length != limit) {
            self.canLoadMore = false;
          } else {
            self.canLoadMore = true;
          }
        })
        .catch(function (error) {
          self.output = error;
          self.showError(error);
        });
    },
    registerTraining() {
      if (!localStorage.token) {
        this.goTo('./vc/cadastro');
        // $('#loginModal').modal('show');
        return
      }
      if (this.user.type == 'SALESMAN') {
        this.$router.push('/vc/meus-treinamentos')
      } else {
        this.$swal({
          icon: 'warning',
          title: 'Atenção',
          text: 'Entre como um profissional para cadastrar treinamentos.',
          // footer: '<a href>Why do I have this issue?</a>'
          showCancelButton: false,
          confirmButtonColor: '#053360',
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.isConfirmed) {
            // window.open("./co/vagas", "_self"); 
          }
        })
        return
      }
    },
  }
};
</script>

<style lang="scss">
.training-list-wrapper {
  padding: 30px 0px;

  .title-wrapper {
    display: flex;
    flex-flow: row wrap;

    >div {
      flex: 1;
    }
  }

  .border {
    height: 40px;
    width: 250px;
    border-radius: 12px;

    &-bigger {
      height: 50px;
      width: 300px;
      font-size: 18px;
      margin-top: 40px;
    }
  }

  .training-list {}

}


@media only screen and (max-width: 600px) {

  .training-list-wrapper {
    padding: 0px 15px;

    .title-wrapper {
      .border {
        margin-top: 15px;
        width: 100%;
      }
    }

  }

}
</style>